import React from "react";
import PropTypes from "prop-types";
import {
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

import TableItem from "../../../ui/TableItem";
import {
  currentIntxPropType,
  intersectionsPropType,
} from "../../../util/propTypeHelper";
import CMFsTableRow from "./CMFsTableRow";
import { getSafetyAnalysisType } from "./safetyHelpers";
import { SAFETY_INPUT_TYPES } from "./safetyConstants";
import { AREA_TYPES } from "../../../constants/geographyConstants";
import EmptyCmfRow from "./EmptyCmfRow";

export default function CrashModificationFactorsForm({
  currentIntx,
  errors,
  formData,
  globalAreaType,
  intersections,
  register,
}) {
  const uniqueIntersectionTypes = [
    ...new Set(intersections.map(({ type }) => type)),
  ];

  return (
    <TableContainer
      component={Paper}
      sx={{ marginTop: "30px", maxWidth: "1100px" }}
    >
      <Table aria-label="Crash Modification Factor Defaults Table">
        <TableHead>
          <TableRow>
            {[
              "",
              "Crash Severity",
              "Override Value",
              "Clearinghouse ID / Notes",
            ].map((title) => (
              <TableItem
                key={title}
                header
                size="small"
                sx={{ textAlign: "center" }}
              >
                <b>{title}</b>
              </TableItem>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {uniqueIntersectionTypes.map((intxType) => {
            const safetyAnalysisType = getSafetyAnalysisType({
              currentIntx,
              intxType,
            });

            if (safetyAnalysisType === SAFETY_INPUT_TYPES.CMF) {
              return (
                <React.Fragment key={intxType}>
                  <CMFsTableRow
                    type={intxType}
                    register={register}
                    errors={errors}
                    formData={formData}
                    rowLabel="Fatal and Injury"
                    rowName="fatalInjury"
                    isFirstRow
                  />
                  <CMFsTableRow
                    type={intxType}
                    register={register}
                    errors={errors}
                    formData={formData}
                    rowLabel="Total"
                    rowName="total"
                  />
                </React.Fragment>
              );
            }
            return (
              <EmptyCmfRow
                key={intxType}
                intxType={intxType}
                safetyAnalysisType={safetyAnalysisType}
              />
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

CrashModificationFactorsForm.propTypes = {
  currentIntx: currentIntxPropType.isRequired,
  errors: PropTypes.object.isRequired,
  formData: PropTypes.object.isRequired,
  globalAreaType: PropTypes.oneOf(Object.values(AREA_TYPES)).isRequired,
  intersections: intersectionsPropType.isRequired,
  register: PropTypes.func.isRequired,
};
